import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {Block, BlockHead, BlockHeadContent, BlockTitle} from '../../../components/block/Block';
import Button from '../../../components/button/Button';
import Icon from '../../../components/icon/Icon';
import {Card} from 'reactstrap';
import {Pagination} from '../../../components/pagination/Pagination';
import PromptTable from './components/PromptTable';
import {promptApi} from '../../../api';
import {IPrompt} from './interfaces/IPrompt';
import {usePagination} from '../../../shared/hooks/usePagination';
import PromptFilters from './components/PromptFilter';
import {useTranslation} from 'react-i18next';

const Prompt = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const [promptList, setPromptList] = useState<IPrompt[]>([]);
  const {changeFilterHandler, page, setTotalPages, totalPages, handlePages, pagination} = usePagination();

  useEffect(() => {
    async function getAllPrompts() {
      const {data} = await promptApi.getAllPrompts(pagination);
      setPromptList(data.data);
      setTotalPages(Math.ceil(data?.count / data?.perPage));
    }

    getAllPrompts();
  }, [pagination, setTotalPages]);
  return (
    <>
      <Block size="lg" className="mt-3">
        <BlockHead>
          <BlockHeadContent>
            <div className="row align-items-center gx-0 gx-lg-2">
              <div className="col-xxl-10 col-xl-9 col-lg-8 col-12">
                <BlockTitle tag="h4">{t('administrator.prompts.promptList')}</BlockTitle>
              </div>
              <div className="col-xxl-2 col-xl-3 col-lg-4 col-12  text-end">
                <Button
                  className="btn-block"
                  color="primary"
                  onClick={() => {
                    navigate('/app/admin/prompts/create');
                  }}
                >
                  <Icon name="plus-sm" />
                  {t('administrator.prompts.addNew')}
                </Button>
              </div>
            </div>
            <PromptFilters changeFilterHandler={changeFilterHandler} pagination={pagination} />
          </BlockHeadContent>
        </BlockHead>
        <Card className="card-bordered card-preview">
          <PromptTable promptList={promptList} setPromptList={setPromptList} />
        </Card>
      </Block>

      <div className="d-flex justify-content-end">
        {totalPages <= 1 ? '' : <Pagination page={page} totalPages={totalPages} handlePagination={handlePages} />}
      </div>
    </>
  );
};

export default Prompt;
